import { render } from "./ICEAlert.vue?vue&type=template&id=1ff57258&lang=pug"
import script from "./ICEAlert.vue?vue&type=script&lang=js"
export * from "./ICEAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__